import React from 'react';

function PinPanel({
  title,
  subtitle,
  pin,
  onPinChange,
  onSubmit,
  onCancel,
  busy,
  error,
  notice,
  submitLabel
}) {
  return (
    <form className="pin-panel" onSubmit={onSubmit}>
      <div className="pin-panel-copy">
        <strong>{title}</strong>
        <p>{subtitle}</p>
      </div>
      <label className="pin-field">
        <span>4-digit PIN</span>
        <input
          autoComplete="one-time-code"
          inputMode="numeric"
          maxLength={4}
          onChange={(event) => {
            const next = event.target.value.replace(/\D/g, '').slice(0, 4);
            onPinChange(next);
          }}
          pattern="\d{4}"
          placeholder="••••"
          type="password"
          value={pin}
        />
      </label>
      {error ? <p className="pin-panel-error">{error}</p> : null}
      {notice ? <p className="pin-panel-notice">{notice}</p> : null}
      <div className="pin-panel-actions">
        <button
          className="pin-btn pin-btn-ghost"
          disabled={busy}
          onClick={onCancel}
          type="button"
        >
          Cancel
        </button>
        <button
          className="pin-btn pin-btn-primary"
          disabled={busy || pin.length !== 4}
          type="submit"
        >
          {busy ? 'Working…' : submitLabel}
        </button>
      </div>
    </form>
  );
}

export default PinPanel;
